import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import api from '../../../../../apiSingleton';
import ContactsHidden from './ContactsHidden';
import { Contacts as ContactsButton } from '../../../../Buttons';
import { PAGE_TYPES } from '../../../../../consts';
import IconTrust from '../../../../Icons/IconTrust';

class Contacts extends React.Component {
  constructor (props) {
    super(props);

    this.item = props.item;
    this.rawItem = props.rawItem;

    this.author = this.item.getAuthor();
    this.agency = this.author.getAgency();
    this.contact = this.item.getContact();
    this.phones = this.contact.getPhones()
        .map((c, i) => {
          return (
            <div className='item-contact' key={i}>
              <span className='icon-phone' />
              <span className='content'>{c}</span>
            </div>
          );
        });
    this.hasCallTrackingPhones = this.item.isCallTrackingPhones();

    this.state = {
      show: props.user.getIn(['data', 'isRealtor'], false) || false,
      showMore: this.phones.length <= 2
    };

    this.showContacts = this.showContacts.bind(this);
    this.handlerShowMore = this.handlerShowMore.bind(this);

    this.created = this.item.getCreatedDate().fromNow();
    this.updated = this.item.getUpdatedDate().fromNow();
  }

  hitContacts () {
    this.props.eventShowContacts(this.rawItem);

    api.announcement
        .hitContacts(this.item.getDealType(), this.item.getRealtyType(), this.item.getProperty().getId(), PAGE_TYPES.TYPE_LISTING)
        .catch(x => null);
  }

  showContacts () {
    this.setState({
      show: true,
      showMore: true
    });

    this.hitContacts();
  }

  handlerShowMore (e) {
    e.preventDefault();
    e.stopPropagation();

    this.setState({
      showMore: true
    });

    this.hitContacts();
  }

  renderPhones () {
    const {showMore} = this.state;

    if (showMore) {
      return (<div className='main-param'>{this.phones}</div>);
    }

    return (
      <div className='main-param'>
        {this.phones.slice(0, 2)}
        <div className='btn-show-more' onClick={this.handlerShowMore} href='#'>еще телефоны</div>
      </div>
    );
  }

  render () {
    // TODO: узнать что такое complaintLink() в аренде (связано с МЛС)

    if (!this.author.isExist()) {
      return (
        <ContactsHidden item={this.item} />
      );
    }

    const trusted = this.item.getAuthor().isTrusted();
    const name = this.contact.getName();

    return (
      <Fragment>
        <div className='upper-side'>
        {name && <div className='author'>
          { trusted && <div data-tip data-for='tip-trusted' className='vas-trusted'>
            <IconTrust />
            {name}
          </div> }
          {!trusted && name}
        </div>}

        {this.agency && (
          <div
            className='only-user btn-underline-secondary'
            data-tip={'Объявления от ' + this.agency.getName()}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.props.onUpdateFilter({onlyOwners: null, agencyId: `${this.agency.getId()}`})
            }}
          >
            {this.agency.getType()}
            <br/>
            {this.agency.getName()}
          </div>)
        }
        {this.author.isOwner() && (
          <div
            className='only-user btn-underline-secondary'
            data-tip='Объявления от собственников'
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.props.onUpdateFilter({onlyOwners: 1, agencyId: null})
            }}
          >
            СОБСТВЕННИК
          </div>)
        }
        {
          this.hasCallTrackingPhones && (
            <div className='contacts-description'>
              <span>Сообщения в мессенджерах и СМС не доставляются</span>
            </div>
          )
        }
        {
          this.state.show
          ? (this.renderPhones())
          : <ContactsButton onClick={this.showContacts} value={this.contact.getPhones()[0]} />
        }
        </div>
        <div className='lower-side'>
          <div className='date-value'>{`Добавлено ${this.created}`}</div>
          <div className='date-value'>{`Обновлено ${this.updated}`}</div>
        </div>
      </Fragment>
    );
  }
}

Contacts.propTypes = {
  item: PropTypes.object.isRequired,
  rawItem: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  onUpdateFilter: PropTypes.func.isRequired,

  eventShowContacts: PropTypes.func
};

Contacts.defaultProps = {
  eventShowContacts: () => {}
};

export default Contacts;



// WEBPACK FOOTER //
// ./src/ui/Views/Announcements/FlexItems/Items/Contacts.jsx